import { couponsTypes } from "redux/reducers/coupons/couponsReducer"
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions"
import { api_get, api_post, api_delete } from "services/api"
import { PROYECT } from "services/api"
import { getProductsV2 } from "../products/productsActionV2"
import { orderTypes } from "redux/reducers/orders/orderTypes"

const {
  GET_COUPONS,
  SELECT_COUPON,
  APPLY_COUPON
} = couponsTypes
const { SET_COUPON_ORDER } = orderTypes
const url = `${process.env.REACT_APP_URL}${PROYECT}/coupons`

export const getCoupons = (id) => {
  return async dispatch => {
    dispatch(startRequestComp('loadingCoupons'))
    try {
      await api_get(url).then(resp => {
        dispatch({
          type: GET_COUPONS,
          payload: resp.coupons
        })
        dispatch(stopRequestComp('loadingCoupons'))
      })
    } catch (error) {
      const err = error ? error : 'Error al obtener los cupones'
      dispatch(stopRequestComp('loadingCoupons'))
      dispatch(setSnackbar(err))
    }
  }
}

export const selectCoupon = (coupon) => {
  return {
    type: SELECT_COUPON,
    payload: coupon
  }
}

export const applyCoupon = (form, block, setCouponSelected, couponS) => {
  const applyUrl = `${url}/apply_to_service`
  return async dispatch => {
    dispatch(startRequestComp('loadingApplyCoupon'))
    try {
      await api_post(applyUrl, form).then(reps => {
        dispatch({
          type: APPLY_COUPON,
          payload: reps
        })
        dispatch(stopRequestComp('loadingApplyCoupon'))
        dispatch(setSnackbar('Cupón aplicado correctamente', 'success'))
        setCouponSelected && setCouponSelected(prev => {
          return {
            ...prev,
            _coupon: `${couponS.name} - ${couponS.code}`
          }
        })
        dispatch({
          type: SET_COUPON_ORDER,
          payload: {
            coupon: couponS,
            id: form.id_service
          }
        })
        block && block(true)
      })
      return
    } catch (error) {
      const err = error ? error : 'Error al aplicar el cupon'
      dispatch(stopRequestComp('loadingApplyCoupon'))
      dispatch(setSnackbar(err))
    }
  }
}

export const removeCoupon = (idService, idCoupon, callback) => {
  const removeUrl = `${url}/service`
  return async dispatch => {
    dispatch(startRequestComp('loadingRemoveCoupon'))
    try {
      await api_delete(removeUrl, { id_service: idService, id_coupon: idCoupon }).then(() => {
        dispatch({
          type: SET_COUPON_ORDER,
          payload: {
            coupon: null,
            id: idService
          }
        })
        dispatch(stopRequestComp('loadingRemoveCoupon'))
        dispatch(setSnackbar('Cupón eliminado correctamente', 'success'))
        callback && callback()
      })
    } catch (error) {
      const err = error ? error : 'Error al eliminar el cupón'
      dispatch(stopRequestComp('loadingRemoveCoupon'))
      dispatch(setSnackbar(err))
    }
  }
}